import {useAccountInformation} from 'presentation/pages';
import React, {Fragment} from 'react';

import {ProvidersResults} from './components/ProvidersResults';
import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {OdontoProvidersResultsProps} from './types';

const {earlyAccessDescriptionOdonto} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoProvidersResults(props: OdontoProvidersResultsProps) {
	const {isEarlyAccess} = useAccountInformation();

	return (
		<Fragment>
			{isEarlyAccess ? <AlertInfo.Root>{earlyAccessDescriptionOdonto}</AlertInfo.Root> : null}

			<ProvidersResults {...props} />
		</Fragment>
	);
}
